export default __webpack_public_path__ + "static/media/CIO_Labor_Category_Descriptions.0bc5e1b2.pdf";